import { bootstrap } from './bootstrap-demo';

bootstrap();

export * from './lib/Legitimate';
export * from './bootstrap-demo';



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/